export default __webpack_public_path__ + "static/media/Group 21.410de160.png";